/* Phones (BNJMN, 4 Nov 2026): scrolling down fades the header away, scrolling up brings it back. Under 750px only. */
(function () {
  const phone = window.matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const TOP = 40;      // near the top the header always shows
  const STEP = 6;      // px of movement in one direction before it reacts
  let last = window.scrollY;
  let travelled = 0;
  const show = () => root.classList.remove('ve-hdr-hide');
  const hide = () => root.classList.add('ve-hdr-hide');
  window.addEventListener('scroll', () => {
    if (!phone.matches) { show(); return; }
    const y = Math.max(window.scrollY, 0);
    const max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    if (y > max) { last = y; return; } // iOS bounce at the bottom
    const delta = y - last;
    last = y;
    if (y <= TOP) { travelled = 0; show(); return; }
    if (root.classList.contains('ve-pt-active') || root.classList.contains('ve-pf-open')) { show(); return; }
    if (delta === 0) return;
    travelled = Math.sign(delta) === Math.sign(travelled) ? travelled + delta : delta;
    if (travelled > STEP) hide();
    else if (travelled < -STEP) show();
  }, { passive: true });
  phone.addEventListener('change', show);
})();
